<label class="label" (click)="toggle($event)" [ngClass]="{'label--checked' : checked}">
    <i class="checkmark far fa-check-square" [ngClass]="{'fa-check-square' : checked, ' fa-square' : !checked}"></i>
    <input class="option option--checkbox" type="checkbox">
    <span [innerHTML]="label"></span>
</label>
